import React from 'react'

function Footer() {
    return (
      <div className="w-full mt-40 pb-10">
        <img src="/images/layout/footer.png" className='opacity-30'  alt="" />
         <div className="flex flex-col justify-center items-center">
            <h1 className='text-[30px] mt-10'>CONTACT <b className='color-pink'>US</b></h1>
            <p className='text-[18px]'>Phone Number: +383 49 368 879</p>
            <p className='text-[18px]'>Email: filomenasflowers@hotmail.com</p>
            <p className='text-[18px]'>Instagram: filomenasflowers_prizren</p>
            <p className='text-[18px]'>Facebool: filomenasflowers</p>
         </div>
      </div>
    )
}

export default Footer